export const getText = (price) => {
  return `Se sumarán $ ${price} pesos por cada unidad`;
};
